var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-pagination-nav',{attrs:{"link-gen":_vm.linkGen,"number-of-pages":_vm.totalPages,"use-router":""},on:{"change":_vm.clickPage}})}
var staticRenderFns = []

export { render, staticRenderFns }